import React from 'react';
import styled, { css } from 'styled-components';

import {
  IconButton,
  ButtonType,
  ButtonTone,
} from '@prisjakt/ui/button/variants';
import GiftIcon from 'mdi-react/GiftIcon';
import Badge from '../badge';

type Props = {
  onClick: () => void;
  alternatePosition?: boolean;
};

export default function ChangelogToggle({ onClick, alternatePosition }: Props) {
  return (
    <Button
      onClick={onClick}
      $alternateStyling={alternatePosition}
      type={alternatePosition ? ButtonType.TEXT : ButtonType.TONAL}
      tone={alternatePosition ? ButtonTone.LIGHT : ButtonTone.DARK}
    >
      <Inner $alternateStyling={alternatePosition}>
        <Badge noOutline={alternatePosition} />
        <GiftIcon size={20} />
      </Inner>
    </Button>
  );
}

type StyleProps = {
  $alternateStyling?: boolean;
};

const Button = styled(IconButton)<StyleProps>(
  p => css`
    && {
      ${p.$alternateStyling &&
        css`
          position: relative;
          color: ${p.theme.icons.secondary};
        `};
    }
  `
);

const Inner = styled.div<StyleProps>`
  position: ${p => (p.$alternateStyling ? 'relative' : 'unset')};
  display: flex;
`;
